
            <div class="ml-2" [ngStyle]="{'margin-top': categoryId === 2 ? ''  : ''}">
              <p style="font-family: 'Rubik', serif; font-size: 16px; font-weight: 400; position: relative; color: #7e807f; margin-bottom: 0px; height: 18px;">Desde</p>
            </div>
             <div *ngIf="pricesData?.currency" class="ml-2">
              <p style="font-family: 'Rubik', serif; height: 20px; margin-bottom: 0; font-weight: 400;color: #7e807f;font-weight: 500;">{{pricesData?.currency}}</p>
            </div>
            <div class="d-flex flex-column ml-2">
              <div class="d-flex">
                <p style="font-family: 'Rubik', serif; font-size: 29px; font-weight: 600; line-height:1; position: relative; margin-bottom: 0; color: #2e2f43"
                  [ngStyle]="{'font-size': pricesData?.price | dynamicFontSize: 30 : fontSizeAdjustments}">
                  {{ pricesData?.price | number: '1.2-2'}}
                </p>
                <usb-tooltip-convert-amount [clientsSettingAppBooking]="clientsSettingAppBooking"
                  [currencyProduct]="pricesData?.originalCurrency"
                  [valueProduct]="pricesData?.originalPrice">
                </usb-tooltip-convert-amount>
              </div>
              <div *ngIf="pricesData?.originalCurrency !== pricesData?.currency" class="d-flex">
                <p class="rubik-regular-12pt mb-0"
                >({{pricesData?.originalCurrency}}) {{ pricesData.originalPrice | number: '1.2-2'}}</p>
              </div>
            </div>

            <div style="margin-top: 16px" class="ml-2">
              <p  class="mb-0 rubik-regular-12pt" style="font-weight: 600">{{pricesData?.totalLabel}}</p>
              <p  class="mb-0 rubik-regular-12pt" >Impuestos incluidos</p>
            </div>
            